import { RPDF } from '../common/react-pdf';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import React from 'react';
import { ChartInfo } from '../common/types';
import { VisitsChart } from '../svg/Chart';
import { ReportInfoTitle } from './ReportInfoTitle';
import { VisitTypesList } from './VisitTypesList';

interface Props {
  data: ChartInfo[];
}

export const ReportStatistics: React.FC<Props> = (props) => {
  const i18next = useScopedTranslation('calendar.report');
  return (
    <RPDF.View style={RPDF.chartStyles.container}>
      <ReportInfoTitle text={i18next.t('statistics_title')} />
      <RPDF.View style={RPDF.chartStyles.dataContainer}>
        <VisitsChart data={props.data} />
        <VisitTypesList data={props.data} />
      </RPDF.View>
    </RPDF.View>
  );
};
